/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import * as React from "react";
import { HotkeysProvider } from "./hotkeys/hotkeysProvider";
import { OverlaysProvider } from "./overlays/overlaysProvider";
import { PortalProvider } from "./portal/portalProvider";
/**
 * Composite Blueprint context provider which enables & manages various global behaviors of Blueprint applications.
 *
 * @see https://blueprintjs.com/docs/#core/context/blueprint-provider
 */
export var BlueprintProvider = function (_a) {
    var children = _a.children, hotkeysProviderValue = _a.hotkeysProviderValue, props = __rest(_a, ["children", "hotkeysProviderValue"]);
    return (React.createElement(PortalProvider, __assign({}, props),
        React.createElement(OverlaysProvider, null,
            React.createElement(HotkeysProvider, __assign({ value: hotkeysProviderValue }, props), children))));
};
//# sourceMappingURL=blueprintProvider.js.map